export const TICKET = {
    NEW: "00-0000"
};

export const PIVOTKEYS = {
    ALLTICKETS: "all-tickets",
    MYTICKETS: "my-tickets",
    CUSTOMIZED: "custom-view-"
}